import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import {
  BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
  makeBriefDeliverableQueryKey,
  makeBriefDeliverablesQueryKey,
} from "../constants";
import { BriefService } from "../services/brief.service";

export function useAttachBriefDeliverable(briefId: string) {
  const {
    mutate: attachBriefDeliverable,
    isLoading: isAttaching,
    isSuccess: isAttached,
    error: attachBriefDeliverableError,
  } = useMutation({
    mutationFn: (data: {
      deliverableId: string;
      briefInfluencerIds: string[];
      resetCost?: boolean
    }) =>
      BriefService.attachBriefDeliverable(
        data.briefInfluencerIds,
        data.deliverableId,
        data.resetCost
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c, _, { deliverableId }) => {
      // ToastService.success("Deliverable attached successfully");

      c.invalidateQueries({ queryKey: makeBriefDeliverablesQueryKey(briefId) });
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });
      c.invalidateQueries({
        queryKey: makeBriefDeliverableQueryKey(deliverableId),
      });
    },
  });

  return {
    attachBriefDeliverable,
    isAttaching,
    isAttached,
    attachBriefDeliverableError,
  };
}
